const CHIP_LABELS_ENUM = {
  CARRIER_CNPJ: 'carrierCnpj',
  SCHEDULED: 'scheduled',
  NF_TYPE: 'nfType',
  FOLLOWING: 'following',
  LIST_COMPANY: 'listCompany',
  LIST_REGION: 'listRegion',
  LIST_STATUS_PERFORMANCE_TMS: 'listStatusPerformanceTms',
  LIST_STATUS_PERFORMANCE_WMS: 'listStatusPerformanceWms',
  LIST_ALLOWANCE: 'listAllowance',
  LIST_CONTRACTED_SERVICE: 'listContractedService',
  LIST_STATUS: 'listStatus',
  LIST_PERFORMANCE: 'listPerformance',
  LIST_CUSTOMER_TMS: 'listCustomerTMS',
  LIST_SUBSIDIARIES: 'listSubsidiaries',
  LIST_SUBSIDIARIES_LUFT: 'listSubsidiariesLuft',
};

export const chipLabelEnumTransKey = {
  [CHIP_LABELS_ENUM.CARRIER_CNPJ]: 'Transportadora',
  [CHIP_LABELS_ENUM.SCHEDULED]: 'Agendamento',
  [CHIP_LABELS_ENUM.NF_TYPE]: 'Tipo de nota',
  [CHIP_LABELS_ENUM.FOLLOWING]: 'Acompanhamento',
  [CHIP_LABELS_ENUM.LIST_COMPANY]: 'Filial Emissora',
  [CHIP_LABELS_ENUM.LIST_REGION]: 'Região',
  [CHIP_LABELS_ENUM.LIST_STATUS_PERFORMANCE_TMS]: 'Destinatário',
  [CHIP_LABELS_ENUM.LIST_STATUS_PERFORMANCE_WMS]: 'WMS',
  [CHIP_LABELS_ENUM.LIST_ALLOWANCE]: 'Abono',
  [CHIP_LABELS_ENUM.LIST_CONTRACTED_SERVICE]: 'Serviço Contratado',
  [CHIP_LABELS_ENUM.LIST_STATUS]: 'Status',
  [CHIP_LABELS_ENUM.LIST_PERFORMANCE]: 'Performance',
  [CHIP_LABELS_ENUM.LIST_CUSTOMER_TMS]: 'Destinatário',
  [CHIP_LABELS_ENUM.LIST_SUBSIDIARIES]: 'Filial Luft',
  [CHIP_LABELS_ENUM.LIST_SUBSIDIARIES_LUFT]: 'Filial Luft',
};

export const FILTERS_NOT_USED_BY_THE_CHIP = {
  INITIAL_PERIOD: 'initialPeriod',
  FINAL_PERIOD: 'finalPeriod',
  CURRENT_PAGE: 'currentPage',
  PAGE_LIMIT: 'pageLimit',
  QUERY: 'query',
  BY_DATE: 'byDate',
}
